import React, {useCallback, useContext} from "react";
import {WizardContext} from "../Wizard";
import {CHANGE_OPTION_INPUT_DATA} from "../../WizardConstants";

export function WizardFormInput({ data }) {
    const { dispatch } = useContext(WizardContext);
    const onChange = useCallback((e) => {
            dispatch({ type: CHANGE_OPTION_INPUT_DATA, dataName: e.target.name, optionValue: e.target.value })
        },
        [dispatch],
    );
    return (
        <div className="form-group">
            <input type="text" className="form-control form-control-solid form-control-lg"
                   name={data.name} placeholder={data.name}
                   defaultValue="" onChange={onChange}/>
        </div>
    )
}